const mediaLightbox = [
    {
        selector: '[data-ls-image]',
        path: { filename: 'imageLightbox' },
    },
];

export { mediaLightbox };
